/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserAccountSummary
 */
export interface UserAccountSummary {
    /**
     *
     * @type {number}
     * @memberof UserAccountSummary
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserAccountSummary
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof UserAccountSummary
     */
    username?: string;
}

/**
 * Check if a given object implements the UserAccountSummary interface.
 */
export function instanceOfUserAccountSummary(
    value: object,
): value is UserAccountSummary {
    return true;
}

export function UserAccountSummaryFromJSON(json: any): UserAccountSummary {
    return UserAccountSummaryFromJSONTyped(json, false);
}

export function UserAccountSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserAccountSummary {
    if (json == null) {
        return json;
    }
    return {
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        name: json["name"] == null ? undefined : json["name"],
        username: json["username"] == null ? undefined : json["username"],
    };
}

export function UserAccountSummaryToJSON(
    value?: UserAccountSummary | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userAccountId: value["userAccountId"],
        name: value["name"],
        username: value["username"],
    };
}
